module.exports = __webpack_public_path__ + "11d74924c82277472c92b5082a9fd183.pdf";